import { Power, Menu, User, Moon, Sun } from 'react-feather'
import { useSkin } from '@hooks/useSkin'
import { Button, ListGroup, ListGroupItem } from 'reactstrap'
import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { useOnClickOutside } from '@hooks/useOnClickOutside'

// ** Store & Actions
import { useDispatch } from 'react-redux'
import { handleLogout } from '@store/actions/auth'

const CustomNavbar = props => {

  const dropDownMenuRef =  useRef()
  const [open, setOpen] = useState(false)

  const [skin, setSkin] = useSkin()
  const darkLogoSrc = require('@src/assets/images/logo/logo_brasal_h_w.png').default
  const lightLogoSrc = require('@src/assets/images/logo/logo_brasal_h.png').default
  const [logoSrc, setLogoSrc] = useState(lightLogoSrc)

  const [menuBg, setMenuBg] = useState('#FFFFFF')
  useEffect(() => {
    setMenuBg(
      skin === 'dark' ? '#283046' : '#FFFFFF'
    )
    setLogoSrc(
      skin === 'dark' ? darkLogoSrc : lightLogoSrc
    )
  }, [skin]) 

  const dispatch = useDispatch()

  const ThemeToggler = () => {
    if (skin === 'dark') {
      return (
        <Sun className='ficon text-primary' size={19} onClick={() => setSkin('light')} />
      )
    } else {
      return (
        <Moon className='ficon text-primary' size={19} onClick={() => setSkin('dark')} />
      )
    }
  }

  const ToggleTheme = () => {
    if (skin === 'dark') {
      setSkin('light')
    } else {
      setSkin('dark')
    }
  }

  useOnClickOutside(dropDownMenuRef, () => {
    setOpen(false)
  })

  const MyMenu = React.forwardRef((props, ref) => (
    <>
      <Button color="flat-primary" onClick={() => props.setOpen()} className='nav-closed'>
        <Menu />
      </Button>
      {!!props.open && 
      <div ref={ref}>
        <ListGroup style={{backgroundColor: menuBg}} flush className="my-dropdown-menu">
          {props.children}
        </ListGroup>
      </div>}
    </>
  ))

  return (
    <div className='my-navbar'>
      <Link className='nav-link-style' to='/'>
        <img className='logo_brasal' src={logoSrc} />
      </Link>
      <nav className="nav-open">
        <ThemeToggler />
        <Button className='ml-75 mr-75' color="flat-primary" tag={Link} to='/' >
          <span className='align-middle'>Home</span>
        </Button>
        <Button className='ml-75 mr-75' color="flat-primary" tag={Link} to='/minha-conta' >
          <span className='align-middle'>Minha Conta</span>
        </Button>
        <Button color="flat-primary" tag={Link} to='/login' onClick={() => dispatch(handleLogout())}>
          <Power size={14} className='mr-75' />
          <span className='align-middle'>Sair</span>
        </Button>
      </nav>
      
      <nav className="nav-closed">
        <MyMenu ref={dropDownMenuRef} open={open} setOpen={() => setOpen(!open)}>
          <ListGroupItem href='/' tag='a'>
            Home
          </ListGroupItem>
          <ListGroupItem href='/minha-conta' tag='a'>
            Minha Conta
          </ListGroupItem>
          <ListGroupItem tag='a' href='#' onClick={ToggleTheme}>
            Mudar tema
          </ListGroupItem>
          <ListGroupItem tag={Link} to='/login' onClick={() => dispatch(handleLogout())}>
            <Power size={14} className='mr-75' />
            Sair
          </ListGroupItem>
        </MyMenu>
      </nav>
    </div>
  )
}

export default CustomNavbar
